import { useEffect } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import { BuyApartmentFlowPaths, CommonPaths } from '../../routes';
import Menu from 'components/menu';
import IconButton from 'components/icon-button';
import Button from 'components/button';
import Header from '../../components/header';
import caretLeft from 'assets/images/caret-left.svg';
import reit from '../../assets/images/itreit_logo.jpg';
import styles from './styles.module.scss';
import useBoundStore from '../../store';
import useLimitsSecondary from '../../api/hooks/use-limits-secondary';
import { MarketTypes } from '../../api/types';
import { DEFAULT_ROOM_COUNT_ARRAY } from '../../lib/constants';

export type ScreenProps = {
  controls?: React.ReactNode;
};

const ScreenBuyMode: React.FC<ScreenProps> = (props) => {
  const navigate = useNavigate();
  const { controls } = props;
  const { filterLimits } = useLimitsSecondary(true, MarketTypes.SECONDARY);

  const clearApartmentSliceSecondary = useBoundStore((s) => s.clearApartmentSliceSecondary);
  const setSelectedFullListCount = useBoundStore((s) => s.setSelectedFullListCount);

  useEffect(() => {
    clearApartmentSliceSecondary();
    setSelectedFullListCount(filterLimits?.roomCount ?? DEFAULT_ROOM_COUNT_ARRAY);
  }, []);

  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <div>
          <Menu />
          <IconButton icon={caretLeft} onClick={() => navigate(CommonPaths.home)} />
        </div>
        <h1 className={styles.title}>Подбор объектов</h1>
        <div>{controls}</div>
      </header>

      <section
        style={{
          marginBottom: 0,
        }}
        className={clsx(styles.content, styles.contentWithPadding)}
      >
        <div className={styles.containerButton}>
          {/* <img className={styles.house} src={house} width={187} alt='Дом с ключём' /> */}
          <img
            className={styles.reit}
            src={reit}
            width={350}
            alt='Логотип reit'
            style={{ marginTop: 180 }}
          />
          <Header className={styles.text} text='Сервис умных сделок с недвижимостью' />
        </div>
      </section>

      <footer className={styles.buttons}>
        <Button
          label={'Первичное жилье'}
          onClick={() => navigate(BuyApartmentFlowPaths.main)}
          variant={'dark'}
        />
        <Button
          label={'Вторичное жилье'}
          onClick={() => {
            navigate(BuyApartmentFlowPaths.buySecondary);
          }}
          variant={'secondary'}
        />
      </footer>
    </main>
  );
};

export default ScreenBuyMode;
